import React, { useEffect, useState } from 'react';
import RouterProvider from '../src/router';
import { useAppDispatch } from './redux/hooks';
import { loadConfig as loadApi } from './redux/reducers/apiConfigReducer';
import { loadBrandGroupConfig as loadBrandGroups } from './redux/reducers/brandGroupConfigReducer';
import { setValidationProperties } from './redux/reducers/validationPropertiesReducer';
import { AuthenticationProvider } from './providers/AuthenticationProvider';
import { brandGroupService } from './services/brandGroupService';
import { configService } from './services/configService';
import { useLocation } from 'react-router-dom';
import { validationService } from './services/validationService';
import Loader from './components/WrapperComponents/Loader';
import { ErrorFallBack } from './views/Error';
import { ErrorBoundary } from 'react-error-boundary';

import './index.scss';
import { loadCountryConfig } from './redux/reducers/countryConfigReducer';
import { loadRegistrationFlowOrchestration } from './redux/reducers/registrationFlowOrchestrationReducer';

function App() {
  const [configLoaded, setConfigLoaded] = useState(false);
  const [allConfigsLoaded, setAllConfigsLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const location = useLocation();

  const loadApiConfig = async () => {
    await configService.getApiConfig().then((response) => {
      dispatch(loadApi(response));
      setConfigLoaded(true);
    });
  };

  const loadBrandGroupConfig = async () => {
    await brandGroupService
      .getBrandGroups()
      .then((response) => dispatch(loadBrandGroups(response)));
  };

  const loadValidationProperties = async () => {
    await validationService
      .getValidationProperties()
      .then((response) => dispatch(setValidationProperties(response)));
  };

  const getCountryConfig = async () => {
    await configService
      .getCountryConfig()
      .then((response) => dispatch(loadCountryConfig(response)));
  };

  const getRegistrationFlowOrchestration = async () => {
    await configService
      .getRegistrationFlowOrchestration()
      .then((response) => dispatch(loadRegistrationFlowOrchestration(response)));
  };

  useEffect(() => {
    loadApiConfig().then(() =>
      Promise.all([
        loadBrandGroupConfig(),
        loadValidationProperties(),
        getCountryConfig(),
        getRegistrationFlowOrchestration(),
      ]).then(() => setAllConfigsLoaded(true))
    );
  }, [loading]);

  if (!configLoaded) return null;
  return (
    <ErrorBoundary FallbackComponent={ErrorFallBack} resetKeys={[location]}>
      <AuthenticationProvider setLoading={setLoading}>
        {!loading && allConfigsLoaded ? <RouterProvider /> : <Loader />}
      </AuthenticationProvider>
    </ErrorBoundary>
  );
}

export default App;
